import React from 'react';
import PropTypes from 'prop-types';
import ADLogoSVG from '../../assets/work-logos/ad-logo.svg';
import ADWorkLogoSVG from '../../assets/work-logos/ad-work-logo.svg';
import ADPLogoSVG from '../../assets/work-logos/adp-logo.svg';
import AmerluxSVG from '../../assets/work-logos/amerlux-logo.svg';
import AllCladLogoSVG from '../../assets/work-logos/all-clad-logo.svg';
import DupontLogoSVG from '../../assets/work-logos/dupont-logo.svg';
import CentricaLogoSVG from '../../assets/work-logos/centrica-logo.svg';
import HeinekenLogoSVG from '../../assets/work-logos/heineken.svg';
import InfoSysLogoSVG from '../../assets/work-logos/infosys-logo.svg';
import PhilipsSVG from '../../assets/work-logos/philips.svg';
import LGLogoSVG from '../../assets/work-logos/lg-logo.svg';
import RicohSVG from '../../assets/work-logos/ricoh-logo.svg';
import SignifySVG from '../../assets/work-logos/signify-logo.svg';
import SteveMaddenLogoSVG from '../../assets/work-logos/steve-madden-logo.svg';
import FirmenichLogoSVG from '../../assets/work-logos/firmenich-logo.svg';
import LupinLogoSVG from '../../assets/work-logos/lupin-logo.svg';
import PeprotechLogoSVG from '../../assets/work-logos/peprotech-logo.svg';
import PinnacleLogoSVG from '../../assets/work-logos/pinnacle-logo.svg';
import QuestDiagnosticsLogoSVG from '../../assets/work-logos/quest-diagnostics-logo.svg';
import BrandingMessaging from '../../assets/services-logos/branding-messaging.svg';
import Digital from '../../assets/services-logos/digital.svg';
import EmployeeExperience from '../../assets/services-logos/employee-experience.svg';
import StrategicMarketing from '../../assets/services-logos/strategic-marketing.svg';
import WeichertLogoSVG from '../../assets/work-logos/weichert-logo.svg';

const Logos = ({ slug }) => {
  switch (slug) {
    case 'ad':
      return <ADLogoSVG />;
      break;
    case 'ad-work':
      return <ADWorkLogoSVG />;
      break;
    case 'adp':
      return <ADPLogoSVG />;
      break;
    case 'all-clad':
      return <AllCladLogoSVG />;
      break;
    case 'amerlux':
      return <AmerluxSVG />;
      break;
    case 'branding-and-messaging':
      return <BrandingMessaging />;
    case 'centrica':
      return <CentricaLogoSVG />;
      break;
    case 'digital-engagement':
      return <Digital />;
      break;
    case 'dupont':
      return <DupontLogoSVG />;
      break;
    case 'employee-experience':
      return <EmployeeExperience />;
      break;
    case 'firmenich':
      return <FirmenichLogoSVG />;
    case 'heineken':
      return <HeinekenLogoSVG />;
      break;
    case 'infosys':
      return <InfoSysLogoSVG />;
      break;
    case 'lg':
      return <LGLogoSVG />;
      break;
    case 'lupin':
      return <LupinLogoSVG />;
    case 'peprotech':
      return <PeprotechLogoSVG />;
    case 'pinnacle':
      return <PinnacleLogoSVG />;
    case 'philips':
      return <PhilipsSVG />;
      break;
    case 'quest-diagnostics':
      return <QuestDiagnosticsLogoSVG />;
    case 'ricoh':
      return <RicohSVG />;
    case 'signify':
      return <SignifySVG />;
      break;
    case 'strategic-marketing':
      return <StrategicMarketing />;
      break;
    case 'steve-madden':
      return <SteveMaddenLogoSVG />;
      break;
    case 'weichert-franchising':
      return <WeichertLogoSVG />;
      break;
    default:
      return <React.Fragment />;
  }
};

Logos.propTypes = {
  slug: PropTypes.string,
};

export default Logos;



// WEBPACK FOOTER //
// ./src/components/logos/index.js